// components/AboutSection.jsx
import React from "react";

const AboutSection = () => {
    return (
        <section id="about" className="about-section">
            <div className="container">
                <h2 className="section-title">ABOUT BUNDLE MADNESS</h2>
                <h3 className="section-header">Why settle for average when luxury hair is within reach?</h3>
                <div className="row justify-content-center">
                    <div className="col-md-10 text-center">
                        <p style={{ fontSize: '1.2rem', lineHeight: '2.2' }}>
                            Welcome to <span style={{ color: 'var(--primary-gold)', fontWeight: '600' }}>BundleMadness Hair</span>,
                            where each strand embodies pure luxury and refinement. We take pride in
                            offering an experience that departs from conventional notions of hair beauty — elevating quality and
                            authenticity in every detail.
                        </p>
                        <p style={{ fontSize: '1.15rem', lineHeight: '2.1' }}>
                            At BundleMadness Hair, we specialize in a curated selection of{' '}
                            <span style={{ color: 'var(--primary-gold)' }}> 100% Top Burmese virgin hair</span>,
                            and raw Cambodian hair, available in a range of textures to suit every look.
                            Every bundle is carefully selected for its softness, fullness, and long-lasting beauty designed to be worn,
                            restyled, coloured, and enjoyed time and time again.
                        </p>
                        <p>From sleek finishes to voluminous curls, each bundle is created to maintain its beauty while blending effortlessly into your desired look.</p>
                        <p style={{
                            fontSize: '1.25rem',
                            lineHeight: '2',
                            fontStyle: 'italic',
                            color: 'var(--primary-gold)',
                            marginTop: '2.5rem',
                            fontFamily: "'Cormorant Garamond', serif"
                        }}>
                            Experience the difference in every detail, because you deserve
                            hair that's as exceptional as you are.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;